export const colors = {
  black: "#222222",
  white: "#FFFFFF",
  grey1: "#efefef",
  grey2: "#C7CBCC",
  grey3: "#868686",
  grey4: "#444444",
  grey5: "#333333",
  yellow: "#FEC748",
  darkYellow: "#ffbb10",
  statusInfoBackground: "#D9EBFB",
  statusInfoText: "#5C84A8",
  statusSuccessBackground: "#E7FAF5",
  statusSuccessText: "#688D84",
  statusWarningBackground: "#FFF4E5",
  statusWarningText: "#9C825F",
  statusErrorBackground: "#FDE9E9",
  statusErrorText: "#9B6C6C"
};
